import publicSrc from './public';

const env = process.env.NODE_ENV || 'development';

const imageSrc = {
  development: `${publicSrc}/images`,
  staging: `${publicSrc}/images`,
  production: `${publicSrc}/images`,
}

const defaultExport = imageSrc[env];

export default defaultExport;
